export const ON_SELECTED_CHART_TYPE_CHANGE = "ON_SELECTED_PRIMARY_CHART_TYPE_CHANGE";



// WEBPACK FOOTER //
// ./src/store/analytics/chart-type-icons/actions.js